import {all} from "redux-saga/effects";
import {combineReducers} from "redux";

import * as auth from "../app/modules/Auth/_redux/authRedux";
import {usersSlice} from "../app/modules/Users/_redux/usersSlice";
import {registrationDataSlice} from "../app/modules/RegistrationData/_redux/registrationDataSlice";
import {userDetailsSlice} from "../app/modules/UserDetails/_redux/userDetailsSlice";
import {invoicesSlice} from "../app/modules/Invoices/_redux/invoicesSlice";
import {invoiceOrdersEditAndSendSlice} from "../app/modules/InvoiceOrders/_redux/invoiceOrdersEditAndSendSlice";
import {invoiceOrdersConfirmCustomersSlice} from "../app/modules/InvoiceOrders/_redux/invoiceOrdersConfirmCustomersSlice";
import {popupEditRowDataSlice} from "../app/modules/InvoiceOrders/_redux/popupEditRowDataSlice";
import {popupConfirmCustomerSlice} from "../app/modules/InvoiceOrders/_redux/popupConfirmCustomerSlice";
import {paymentsSlice} from "../app/modules/AutomatedPayments/_redux/paymentsSlice";
import {receiptsSlice} from "../app/modules/Receipts/_redux/receiptsSlice";
import globalMessageReducer from "../app/modules/_common/reducers/globalMessageReducer";
import progressBarPopUpReducer from "../app/modules/_common/reducers/progressBarPopUpReducer";
import {popupInvoicesListSlice} from "../app/modules/Receipts/components/PopupAddReceipt/components/PopupInvoicesList/redux/popupInvoicesListSlice";
import {popupAddReceiptSlice} from "../app/modules/Receipts/components/PopupAddReceipt/_redux/popupAddReceiptSlice";
import {completeDetailsSlice} from "../app/modules/CompleteDetails/_redux/completeDetailsSlice";
import {partnersSlice} from "../app/modules/Partners/_redux/partnersSlice";
import {invitedUsersSlice} from "../app/modules/InvitedUsers/_redux/invitedUsersSlice";
import {customersSlice} from "../app/modules/Customers/_redux/customersSlice";
import {agentsIncomesSlice} from "../app/modules/AgnetsIncomes/_redux/agentsIncomesSlice";
import {projectsSlice} from "../app/modules/Projects/_redux/projectsSlice";
import {customersForProjectsSlice} from "../app/modules/Projects/_redux/customersForProjectsSlice";
import {markedIgnoredCustomersSlice} from "../app/modules/Projects/_redux/markedIgnoredCustomersSlice";
import {unpaidAgentsSlice} from "../app/modules/UnpaidAgents/_redux/unpaidAgentsSlice";
import {transfersByAgentSlice} from "../app/modules/TransfersByAgent/_redux/transfersByAgentSlice";
import {transferSlice} from "../app/modules/TransfersByAgent/_redux/transferSlice";
import {usersActionsSlice} from "../app/modules/UsersActions/_redux/usersActionsSlice";
import {paypalRequestsSlice} from "../app/modules/PaypalRequests/_redux/paypalRequestsSlice";
import {transfersSlice} from "../app/modules/Transfers/_redux/transfersSlice";
import {notificationsSlice} from "../app/modules/Notifications/_redux/notificationsSlice";
import {lawAgentsSlice} from "../app/modules/Law/_redux/lawAgentsSlice";
import {lawTransactionsSlice} from "../app/modules/Law/_redux/lawTransactionsSlice";
import {usersClientActionsSlice} from "../app/modules/UsersClientActions/_redux/usersClientActionsSlice";
import {aiReportsSlice} from "../app/modules/AiReports/_redux/aiReportsSlice";
import {savedQueriesSlice} from "../app/modules/AiReports/_redux/savedQueriesSlice";

export const rootReducer = combineReducers({
  auth: auth.reducer,
  users: usersSlice.reducer,
  registrationData: registrationDataSlice.reducer,
  userDetails: userDetailsSlice.reducer,
  invoices: invoicesSlice.reducer,
  receipts: receiptsSlice.reducer,
  invoiceOrdersConfirmCustomers: invoiceOrdersConfirmCustomersSlice.reducer,
  invoiceOrdersEditAndSend: invoiceOrdersEditAndSendSlice.reducer,
  popupEditRowData: popupEditRowDataSlice.reducer,
  popupConfirmCustomer: popupConfirmCustomerSlice.reducer,
  payments: paymentsSlice.reducer,
  globalMessage: globalMessageReducer,
  progressBarPopUp: progressBarPopUpReducer,
  popupInvoicesList: popupInvoicesListSlice.reducer,
  popupAddReceipt: popupAddReceiptSlice.reducer,
  completeDetails: completeDetailsSlice.reducer,
  partners: partnersSlice.reducer,
  invitedUsers: invitedUsersSlice.reducer,
  customers: customersSlice.reducer,
  agentsIncomes: agentsIncomesSlice.reducer,
  projects: projectsSlice.reducer,
  customersForProjects: customersForProjectsSlice.reducer,
  markedIgnoredCustomers: markedIgnoredCustomersSlice.reducer,
  unpaidAgents: unpaidAgentsSlice.reducer,
  transfersByAgent: transfersByAgentSlice.reducer,
  transfer: transferSlice.reducer,
  usersActions: usersActionsSlice.reducer,
  paypalRequests: paypalRequestsSlice.reducer,
  transfers: transfersSlice.reducer,
  notifications: notificationsSlice.reducer,
  lawAgents: lawAgentsSlice.reducer,
  lawTransactions: lawTransactionsSlice.reducer,
  usersClientActions: usersClientActionsSlice.reducer,
  aiReports: aiReportsSlice.reducer,
  savedQueries: savedQueriesSlice.reducer,
});

export function* rootSaga() {
  yield all([auth.saga()]);
}
